module.exports = __webpack_public_path__ + "6c4a0dbc/img/product-icon-grey.b248963c.svg";